import { render, staticRenderFns } from "./gj-separator.vue?vue&type=template&id=0beca0cf&scoped=true&"
import script from "./gj-separator.vue?vue&type=script&lang=js&"
export * from "./gj-separator.vue?vue&type=script&lang=js&"
import style0 from "./gj-separator.vue?vue&type=style&index=0&id=0beca0cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0beca0cf",
  null
  
)

export default component.exports